import React, { useEffect, useState } from 'react';

import Link from '../../library/link/link';

import {
  getFallbackProductImageUrl,
  getNormalizedProductType,
  getProductImage
} from '../../shared/utils/product/product';

import { Maybe, ProductData } from '../../shared/types/graphql-types';
import {
  PRODUCT_IMAGE_FORMATS,
  PRODUCT_IMAGE_QUALIFIERS
} from '../../shared/constants/product-images';

import './product-image.scss';

interface ProductImageProps {
  ariaLabel?: string;
  className?: string;
  height?: number;
  imageFormatType?: keyof typeof PRODUCT_IMAGE_FORMATS;
  imageUrl?: string;
  linkUrl?: Maybe<string>;
  onClick?: () => void;
  onError?: () => void;
  product?: ProductData;
  productTypeProp?: string;
  showAngleImage?: boolean;
  width?: number;
}

function ProductImage(props: ProductImageProps) {
  const {
    ariaLabel = '',
    className = '',
    height,
    imageFormatType = 'PRODUCT_SMALL',
    imageUrl,
    linkUrl,
    onClick,
    onError,
    product,
    productTypeProp,
    showAngleImage = false,
    width
  } = props;

  const productType =
    productTypeProp || getNormalizedProductType(product?.productType);
  const name = ariaLabel || product?.name;

  const productImageData = getProductImage(product, {
    format: PRODUCT_IMAGE_FORMATS[imageFormatType],
    qualifier: showAngleImage ? PRODUCT_IMAGE_QUALIFIERS.ANGLE : '',
    shouldFallBackToFirst: true
  });

  const [productImageUrl, setProductImageUrl] = useState(
    imageUrl && typeof imageUrl === 'string'
      ? imageUrl
      : productImageData?.url ||
          product?.primaryImageUrl ||
          getFallbackProductImageUrl(productType)
  );

  const imgTag = (
    <img
      alt={productImageData?.altText || name || ''}
      className="product-image__image"
      data-testid="product-image-block-tid"
      height={height || '100%'}
      onError={() => {
        setProductImageUrl(getFallbackProductImageUrl(productType));
        onError && onError();
      }}
      src={productImageUrl}
      width={width}
    />
  );

  useEffect(() => {
    if (imageUrl && typeof imageUrl === 'string') {
      setProductImageUrl(imageUrl);
    }
  }, [imageUrl]);

  return linkUrl ? (
    <Link
      className={`product-image ${className}`}
      onClick={onClick}
      styleName="container"
      to={linkUrl}
    >
      {imgTag}
    </Link>
  ) : (
    <div className={`product-image ${className}`} styleName="container">
      {imgTag}
    </div>
  );
}

export default ProductImage;
